export const getServiceName = (selectedServiceName: string, isSelectedDateNightTime: boolean): string => {
  if (selectedServiceName === 'Drop Off' || selectedServiceName === 'Pick Up') {
    return selectedServiceName;
  }
  if (isSelectedDateNightTime) {
    return `Date Night Experience - ${selectedServiceName}`;
  }
  return `Standard Appointment - ${selectedServiceName}`;
};
